export const POItemsColumns = [
    {
        field: "serial",
        headerName: "Serial Number"
    },
]

